<template>
  <b-modal
      id="add-advanced-break-type"
      ref="add-advanced-break-type"
      size="sm-size"
      modal-class="advanced-break-modal"
      centered
      hide-footer
      hide-header
      @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{label.get('add_break_type')}}
      </h2>
    </div>
    <div class="content-wrapper">
      <div class="form-container">
        <div class="d-flex justify-content-start align-items-center flex-row">
          <div class="check-wrapper frequency-check">
            <b-form-radio
                class="radio-style"
                v-model="advancedBreakType.frequency"
                name="custom_frequency"
                :value="CUSTOM_FREQUENCY"
            >
              {{ label.get('custom') }}
            </b-form-radio>

          </div>
          <div class="check-wrapper frequency-check">
            <b-form-radio
                class="radio-style"
                v-model="advancedBreakType.frequency"
                name="once_daily_frequency"
                :value="ONCE_DAILY_FREQUENCY"
            >
              {{ label.get('once_daily') }}
            </b-form-radio>

          </div>
        </div>
        <div class="name-holder">
          <span class="heading-title">{{ label.get('name') }}</span>
          <input
              v-model="advancedBreakType.name"
              ref="job"
              type="text"
              name="advanced_break_type_name"
              :placeholder="label.get('add_break_type_name_placeholder')"
              class="atto-input"
          >
        </div>
        <div class="d-flex align-items-center justify-content-between flex-row">
          <div class="break-time-holder">
            <span class="heading-title">{{ label.get('break_time') }}</span>
            <div class="input-wrapper">
              <input
                  v-model="advancedBreakType.break_time"
                  ref="job"
                  type="number"
                  placeholder="15"
                  class="atto-input"
              >
            </div>
          </div>
          <div class="every" v-if="advancedBreakType.frequency === 1">
            <span class="heading-title">{{ label.get('every') }}</span>
            <div class="input-wrapper">
              <time-picker-component
                  class="every-time-picker"
                  v-model="advancedBreakType.every"
                  placeholder="04:00"
                  :add-seconds="false"
                  :format24h="true"
                  :required="true"
              />
            </div>
          </div>

          <div class="type-holder">
            <span class="heading-title">{{ label.get('type') }}</span>
            <select-dropdown-component
                :value="advancedBreakType.type"
                :options="breakTypes"
                @onOptionSelected="onPaidRulesChanged"
            />
          </div>
        </div>
        <p class="info"
           v-if="advancedBreakType.frequency === 0 && advancedBreakType.break_time !== ''"
           v-html="
                  label.get('once_daily_info', {
                    break_time: label.get(advancedBreakType.break_time),
                    type: getTypeLabel(advancedBreakType.type)
                  })
                "
        />
        <p class="info"
           v-if="advancedBreakType.frequency === 1 && advancedBreakType.break_time !== '' && advancedBreakType.every !== ''"
           v-html="
                  label.get('custom_frequency_info', {
                    break_time: label.get(advancedBreakType.break_time),
                    every: getTimeLabel(),
                    type:  getTypeLabel(advancedBreakType.type),
                  })
                "
        />
      </div>
      <div
          v-if="hasError"
          class="error-wrapper"
      >
        <span class="error-message">
          {{label.get('please_fill_the_blank_fields')}}
        </span>
      </div>
      <div
          v-if="hasBreakError"
          class="error-wrapper"
      >
        <span class="error-message">
          {{label.get('break_error')}}
        </span>
      </div>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
            class="atto-btn cancel"
            @click="close"
        >
          {{label.get('cancel')}}
        </button>
        <button
            class="atto-btn submit add-jobs-btn"
            :disabled="disabledSaveButton"
            @click="addAdvancedBreakTypes"
        >
          {{label.get('add_break')}}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";
import BreakPreferencesService from "../services/BreakPreferencesService";
import TimePickerComponent from "../../../timesheets/shared/components/TimePickerComponent";

export default {
  name: "AddAdvancedBreakTypeComponent",
  components: {
    TimePickerComponent,
    SelectDropdownComponent
  },
  data() {
    return {
      disabledSaveButton: false,
      breakTypes: this.getBreakTypes(),
      advancedBreakType: {
        id: null,
        name: '',
        type: 1,
        frequency: 1,
        every: '',
        break_time: ''
      },
      name: '',
      type: '',
      frequency: '',
      every: '',
      break_time: '',
      CUSTOM_FREQUENCY: 1,
      ONCE_DAILY_FREQUENCY: 0,
      hasError: false,
      hasBreakError: false,
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$refs['add-advanced-break-type'].show();
  },
  methods: {
    getBreakTypes(){
      return BreakPreferencesService.getBreakTypes(this.label);
    },
    onPaidRulesChanged(option){
      this.advancedBreakType.type = option.value;
    },
    convertH2M(timeInHour){
      const timeParts = timeInHour.toString().split(":");
      return Number(timeParts[0]) * 60 + Number(timeParts[1]);
    },
    EveryTimeInMinutes(){
      const hm = this.advancedBreakType.every;
      return this.convertH2M(hm);
    },
    getTimeLabel(){
      const hm = this.advancedBreakType.every;
      const [hoursN, minN] = hm.toString().split(':');
      if(hm !== ''){
        let hours = parseInt(hoursN);
        const minutes = parseInt(minN);

        if (hours === 0 && minutes > 1){
          return (minutes + ' minutes ');
        }
        if (hours === 0 && minutes === 1){
          return (minutes + ' minute ');
        }
        if (hours > 1 && minutes === 1){
          return (hours + ' hours ' + minutes + ' minute ');
        }
        if (hours > 1 && minutes > 1){
          return (hours + ' hours ' + minutes + ' minutes ');
        }
        if (hours === 1 && minutes === 0){
          return (hours + ' hour ');
        }
        if (hours === 1 && minutes === 1){
          return (hours + ' hour ' + minutes + ' minute ');
        }
        if (hours === 1 && minutes > 1){
          return (hours + ' hour ' + minutes + ' minutes ');
        }
        if (hours > 1 && minutes === 0){
          return (hours + ' hours ' );
        }
        if (hours === 0 && minutes === 0){
          return '';
        }
      }
    },
    close() {
      this.$root.$emit('hideAddAdvancedBreakType');
    },
    addAdvancedBreakTypes() {
      const data = this.advancedBreakType;
      if (data.length === 0) {
        this.disabledSaveButton = false;
        this.hasBreakError = true;
        this.hasError = true;
        return;
      }

      const everyTime = parseInt(this.EveryTimeInMinutes());
      const breakTime = parseInt(data.break_time);

      if ( everyTime < breakTime ){
        this.disabledSaveButton = false;
        this.hasBreakError = true;
        return;
      }
      this.hasError = false;
      this.hasBreakError = false;
      this.disabledSaveButton = true;

      BreakPreferencesService.saveAdvancedBreakTypes(data).then((result) => {
        this.$root.$emit('hideAddAdvancedBreakType', result.data);
      }).catch((error) => {
        this.disabledSaveButton = false;
        this.hasBreakError = true;
        this.hasError = true;
        return data;

      });
    },
    getTypeLabel(type) {
      const typeObj = this.getBreakTypes().find(x => x.value === type);
      if(typeObj) {
        return typeObj.label;
      }
      return 'Unknown';
    }
  }
}
</script>

<style lang="scss">

.advanced-break-modal{
  .modal-sm-size {
    max-width: 496px;
  }
  .frequency-check{
    margin-right: 25px;
  }
  .heading-title{
    color: #999999;
    @include fontSize(11px);
    @include lHeight(13px);
    letter-spacing: 0.55px;
    text-transform: uppercase;
    font-family: $roboto-font;
    font-weight: $roboto-medium;
    margin-bottom: 4px;
  }
  .name-holder{
    margin: 24px 0 16px;
  }
  .break-time-holder{
    display: flex;
    flex-flow: column;
    min-width: 128px;
    flex-grow: 1;
    .input-wrapper{
      min-width: 128px;
      max-width: 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0;

      &:after{
        content: 'min';
        display: flex;
        width: 48px;
        min-width: 48px;
        height: 40px;
        background: #FAFAFA;
        align-items: center;
        justify-content: center;
        @include fontSize(14px);
        @include lHeight(20px);
        font-family: $roboto-font;
        font-weight: $roboto-medium;
        border: 2px solid #EFEFEF;
      }
      input{
        min-width: 80px;
        max-width: 152px;
        height: 40px;
        border: 2px solid #EFEFEF;
        border-right: none;
        font: 500 0.875rem/1.25rem "Roboto", sans-serif;
        text-indent: 12px;
      }
    }
  }
  .every{
    display: flex;
    flex-flow: column;
    min-width: 128px;
    flex-grow: 1;
    margin: 0 16px;
    .input-wrapper{
      min-width: 128px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0;
      &:after{
        content: 'h';
        display: flex;
        width: 48px;
        min-width: 48px;
        height: 40px;
        background: #FAFAFA;
        align-items: center;
        justify-content: flex-start;
        @include fontSize(14px);
        @include lHeight(20px);
        font-family: $roboto-font;
        font-weight: $roboto-medium;
        border: 2px solid #EFEFEF;
        padding: 8px 12px;
      }
      input{
        min-width: 80px;
        height: 40px;
        border: 2px solid #EFEFEF;
        border-right: none;
        font: 500 0.875rem/1.25rem "Roboto", sans-serif;
      }
    }
  }
  .type-holder{
    flex-grow: 1;
    display: flex;
    flex-flow: column;
    min-width: 128px;
    max-width: 200px;
    width: 100%;
  }
  p.info{
    @include fontSize(15px);
    @include lHeight(20px);
    font-family: $roboto-font;
    font-weight: $roboto-regular;
    color: $atto-font-color;
    display: inline-block;
    margin: 24px 0 0 23px;
    max-width: 316px;

    &:before{
      content: '';
      width: 16px;
      min-width: 16px;
      height: 16px;
      display: flex;
      background: url("../../../../../images/info-green.svg") no-repeat center center;
      background-size: cover;
      margin-right: 8px;
      position: relative;
      top: 17px;
      right: 23px;
    }
  }
}

</style>